// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGCompose = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.054.39c-.521-.52-1.365-.52-1.885 0l-3.166 3.166H3.111C1.396 3.556 0 4.95 0 6.667v14.222C0 22.604 1.396 24 3.111 24h14.222c1.716 0 3.111-1.396 3.111-3.111v-5.333c0-.737-.596-1.334-1.333-1.334-.736 0-1.334.597-1.334 1.334v5.333c0 .244-.199.444-.444.444H3.111c-.244 0-.444-.2-.444-.444V6.667c0-.245.2-.444.444-.444h9.226l-4.835 4.834c-.147.147-.257.325-.322.521l-1.777 5.333c-.16.48-.036 1.007.321 1.365.255.254.595.39.943.39.142 0 .284-.022.422-.069l5.333-1.777c.196-.065.375-.175.52-.322L23.61 5.83c.521-.52.521-1.365 0-1.885L20.054.391z",
      id: "compose__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#compose__a",
    fillRule: "evenodd"
  })]
}));
SVGCompose.displayName = 'SVGCompose';
export default SVGCompose;